export { default } from "./useDeleteContentInTextSet";
